S<template>
  <div class="body-wrapper">
    <Header :title="'Settings'" />
    <div class="body-container">
      <div class="setting-group">
        <div class="video-input">
          <p>Intro Video:</p>
          <div class="video-option dropbox default">
            <div v-if="!introVideo && !introVideoThumbnailUrl" class="default-vid">
              <i class="fas fa-play"></i>
            </div>
            <div class="preview-vid" v-else>
              <video
                autoplay playsinline
                :key="introVideoThumbnailUrl"
                width="320" height="240" controls>
                  <source :src="introVideoThumbnailUrl" type="video/mp4">
                  Your browser does not support the video tag.
              </video>
            </div>
            <input
              type="file"
              @change="
                filesChange($event.target.files, 'introVideo');
                fileCount = $event.target.files.length;
              "
              accept="video/mp4"
              class="input-file"
            />
          </div>
        </div>

        <div class="buttons">
          <button @click="saveIntroVideo()" class="primary-btn">
            SAVE VIDEO
          </button>
        </div>
      </div>

      <div class="setting-group" style="margin-left: 1%">
        <p>Ask for review prompts:</p>
        <ToggleButton @change="saveReviewPromptSettings" :value="review_prompts_enabled" color="#066DCD" :sync="true"/>
      </div>

    </div>
  </div>
</template>

<script>
import Header from "@/components/header/Header";
import { getSettings, saveSettingIntroVideo, saveSettingReview } from '@/api/requests';
import { ToggleButton } from 'vue-js-toggle-button'

export default {
  name: 'Settings',

  components: {
    Header,
    ToggleButton,
  },

  data() {
    return {
      introVideo: null,
      introVideoThumbnailUrl: '',
      review_prompts_enabled: undefined,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.loadSettings();
    });
  },


  methods: {
    loadSettings() {
      getSettings().then(response => {
        if (response.data.intro_video != "") {
          this.introVideoThumbnailUrl = `${this.url}${response.data.intro_video}`;
        }
        this.review_prompts_enabled = response.data.review_prompts_enabled;
      }).catch(() => {
        // TODO errors
      });
    },

    filesChange(fileList, type) {
      this.introVideo = fileList[0];
    },

    saveIntroVideo() {
      let formData = new FormData();
      if (this.introVideo != null) {
        formData.append(
          "intro_video",
          this.introVideo,
          this.introVideo.name
        );
      }

      saveSettingIntroVideo(formData).then((response) => {
        this.$toasted.global.app_success({
          message: "Intro video updated."
        });
      })
      .catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update intro video."
        });
      });
    },

    saveReviewPromptSettings() {
      const payload = {
        'review_prompts_enabled': !this.review_prompts_enabled,
      };
      this.review_prompts_enabled = !this.review_prompts_enabled;
      saveSettingReview(payload).then(() => {
        this.$toasted.global.app_success({
          message: "Review setting updated."
        });
      }).catch(() => {
        this.$toasted.global.app_error({
          message: "Failed to update review setting."
        });
      });
    },
  },

  computed: {

    url() {
      let url = window.location.origin;
      if (url === "http://localhost:8080") {
        url = "http://localhost:3000";
      }
      return url;
    },

    
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.body-container {
  padding: 10px;
  height: calc(100% - 60px);

  .setting-group {
    background: #1B1C27;
    border: 1px solid #ccc;
    border-radius: 10px;
    padding: 10px;
    float: left;
    width: 30%;

    p {
      font-weight: 500;
      font-size: 14px;
      color: #BDBDBD;
      padding: 0;
      margin: 0;
      margin-bottom: 4px;
    }
  }

  .video-input {
    flex: 0;

    p {
      font-weight: 500;
      font-size: 14px;
      color: #BDBDBD;
      padding: 0;
      margin: 0;
      margin-bottom: 4px;
    }
  }

  .dropbox {
    border-radius: 0;
    width: 130px;
    height: 130px;
    border: 1px solid $sec2;
  }

  .default {
    background: $sec0;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;

    img {
      width: 20px;
      height: 20px;
      display: inline-block;
    }
  }
  .default-vid { 
    display: flex;
    align-items: center;
    justify-content: center;

    i {
      font-size: $font-size-base;
      color: $sec4;
      font-weight: bold;
    }
  }

  .preview-vid {
    height: 130px;
    width: 130px;
    position: relative;
    display: flex;
    justify-content: center;

    i {
      right: 5px;
      position: absolute;
      z-index: 1;
      top: 5px;
    }
  }

  #preview {
    width: 100%;
    height: 100%;
  }

}

.buttons {
  width: 200px;
  display: block;
  margin-top: 10px;
}
</style>
